/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

interface TrackingProps {
	locale?: string;
	/** Override for NEXT_PUBLIC_TRACKING_BASE */
	trackingBase?: string;
	/** Override for NEXT_PUBLIC_TRACKING_DISABLED */
	trackingDisabled?: string;
	/** Override for NEXT_PUBLIC_DSA_TRACKING_ID */
	dsaTrackingId?: string;
	/** Override for NEXT_PUBLIC_TRACKING_VERSION */
	trackingVersion?: string;
	/** Override for NEXT_PUBLIC_TRACKING_SCRIPT_HASH */
	trackingScriptHash?: string;
}

export const Tracking = ({
	locale,
	trackingBase,
	trackingDisabled,
	dsaTrackingId,
	trackingVersion,
	trackingScriptHash,
}: TrackingProps): React.JSX.Element | null => {
	const resolvedDisabled = trackingDisabled ?? process.env.NEXT_PUBLIC_TRACKING_DISABLED;
	const resolvedBase = trackingBase ?? process.env.NEXT_PUBLIC_TRACKING_BASE;
	const resolvedDsaId = dsaTrackingId ?? process.env.NEXT_PUBLIC_DSA_TRACKING_ID;
	const resolvedVersion = trackingVersion ?? process.env.NEXT_PUBLIC_TRACKING_VERSION;
	const resolvedHash = trackingScriptHash ?? process.env.NEXT_PUBLIC_TRACKING_SCRIPT_HASH;

	const trackingEnabled = Boolean((!resolvedDisabled || resolvedDisabled === "false") && resolvedBase);

	if (trackingEnabled) {
		const url = new URL(`${resolvedBase}/tracking.js`);

		if (resolvedDsaId) {
			url.searchParams.set("p", resolvedDsaId);
		}

		if (locale) {
			url.searchParams.set("l", locale);
		}

		if (resolvedVersion && resolvedHash) {
			url.searchParams.set("version", resolvedVersion);
			return (
				<script key="tracking-script" crossOrigin="anonymous" integrity={resolvedHash} src={url.toString()} async />
			);
		}

		return <script key="tracking-script" src={url.toString()} async />;
	}

	return null;
};
